<template>
  <div class="webhook-creator">
    <b-row>
      <b-col md="12">
        <p>
          <strong>Url:</strong> <b-form-input ref="url" v-model="webhook.address" :disabled="this.initWebhook !== undefined"/>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p>
          <strong>Nazwa:</strong>
          <b-form-input ref="description" v-model="webhook.description"/>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p>
          <strong>Event:</strong> <b-form-select ref="event" v-model="webhook.event" :options="eventsOptions"/>

        </p>
      </b-col>
    </b-row>
    <hr>
    <b-button variant="primary" class="float-right" @click="saveWebhook()">{{ this.initWebhook ? `Zapisz` : `Utwórz` }}</b-button>
  </div>
</template>
<script>

const events = [
  'LEAD_CREATED'
]

export default {
  props: ['initWebhook', 'variables'],
  components: {},
  data () {
    return {
      webhook: this.initializeWebhook(),
      eventsOptions: [
        { text: events[0], value: events[0] }
      ]
    }
  },
  created () {
  },
  name: 'c-webhook-creator',
  methods: {
    initializeWebhook () {
      if (this.initWebhook) {
        return JSON.parse(JSON.stringify(this.initWebhook))
      }
      return this.empty()
    },
    empty () {
      return {
        address: null,
        event: events[0],
        description: null
      }
    },
    saveWebhook () {
      this.$emit('saved', this.webhook)
    }
  }
}
</script>
